import { IUser } from "./IUser";

export class User implements IUser {
  constructor(
    public firstName: string,
    public lastName: string,
    public email: string,
    public permissions: string[],
    public groups: string[],
    public languageCode: string,
    public countryCode: string,
    public partnerId?: string,
    public subsidiaryId?: string,
  ) {
    // Do nothing
  }

  hasPermissions(permissions: string[]): boolean {
    return this.permissions && permissions.every((it) => this.permissions.includes(it));
  }
}
